"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _occasion = _interopRequireDefault(require("occasion"));
var _sortableRowsContainer = _interopRequireDefault(require("../../../../core/sortable-rows-container"));
var _racePhase = _interopRequireDefault(require("./race-phase"));
var _copyDay = _interopRequireDefault(require("./copy-day"));
var _startListUtils = require("../../start-list/start-list-utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null, "Race"), /*#__PURE__*/_react.default.createElement("th", null, "Phase"), /*#__PURE__*/_react.default.createElement("th", null, "Derived Start"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Fix Start Time"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Secs After Phase"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Secs Between Paddlers"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Only Use Holding Places"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Minimum Places"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Split"), /*#__PURE__*/_react.default.createElement("th", null)));
var _ref2 = /*#__PURE__*/_react.default.createElement("td", {
  colSpan: 12
});
class StartListDay extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onSort", startListRuns => {
      this.props.onSort(this.props.competitionID, this.props.competitionDay.id, startListRuns.map(run => run.id));
    });
    _defineProperty(this, "_startListRunsWithTimes", startListRuns => {
      if (!startListRuns.length) return [];
      let trackedTime = startListRuns[0].fixedStartTime || '08:00:00';
      return startListRuns.map(run => {
        if (run.fixedStartTime) trackedTime = run.fixedStartTime;
        const runWithTime = {
          derivedStart: trackedTime,
          ...run
        };
        const numberOfPlaces = run.onlyUseHoldingPlaces ? run.holdingPlaces : Math.max(run.holdingPlaces,
        // selection Paddlers don't get practice
        run.startListEntries.filter(entry => !entry.isSelectionPaddler || run.phaseRef !== 'PRAC').length);
        if (numberOfPlaces > 0) trackedTime = (0, _startListUtils.addSecondsToTime)(trackedTime, (numberOfPlaces - 1) * run.secsBetweenPaddlers + run.secsAfterPhase);
        return runWithTime;
      });
    });
  }
  render() {
    const day = this.props.competitionDay;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-header"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "pull-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_copyDay.default, {
      competitionDay: day
    })), /*#__PURE__*/_react.default.createElement("h3", null, (0, _occasion.default)(day.dayDate, 'dddd'))), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement(_sortableRowsContainer.default, {
      items: day.startListRuns,
      onSort: this._onSort
    }, /*#__PURE__*/_react.default.createElement("tbody", null, this._startListRunsWithTimes(day.startListRuns).map((run, index) => [!run.fixedStartTime ? null : /*#__PURE__*/_react.default.createElement("tr", {
      key: run.id + 'break',
      className: "table-warning"
    }, _ref2), /*#__PURE__*/_react.default.createElement(_racePhase.default, {
      key: run.id,
      run: run,
      index: index,
      nextDayID: this.props.nextDayID
    })]))))));
  }

  // ****************************************************************************
  // PartialQuery definition
  // ****************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(StartListDay, "partials", {
  CompetitionDay: _mergeBqlQueries({
    id: true,
    dayDate: true,
    startListRuns: _mergeBqlQueries({
      id: true,
      startListEntries: {
        id: true,
        isSelectionPaddler: true
      },
      secsBetweenPaddlers: true,
      secsAfterPhase: true,
      phaseRef: true
    }, _racePhase.default.partials.StartListRun)
  }, _copyDay.default.partials.CompetitionDay)
});
var _default = exports.default = (0, _reactBicycle.connect)(StartListDay, undefined, (client, props) => ({
  onSort(competitionID, dayID, startListRunIDs) {
    return client.update('CompetitionDay.sortStartList', {
      competitionID,
      dayID,
      startListRunIDs
    });
  }
}));